/* LKC wishlist, T6.31 (16 Sep 2026). Hearts, header count, device list for guests, account sync.
   Storage "lkc.wl.v2" = {guest:[ids newest first], hm:{id:handle}, acct:{cid,ids,at}|null,
   out:{cid, ops:[{o:"a"|"r", id, t, s?}], m?:[merged guest ids]}|null}. Logged in = the #lkc-wl-acct island is on the page.
   acct.at = when a sync reply saved acct.ids (0 = copied from an island). op.s = when that op was last sent
   (cleared when the reply is read; an op still marked 10 minutes later was sent by a page that closed first).
   Paint = one <style id="lkc-wl-state"> (first written by snippets/lkc-wishlist-head.liquid).
   Sync = POST <data-api>/v1/sync, text/plain, no cookies. Never throws into the page. */
(function () {
  'use strict';
  if (window.LKCWishlist) return;
  var w = window, d = document, KEY = 'lkc.wl.v2', MAX = 100, SENT_TTL = 600000;
  var me = d.currentScript || d.querySelector('script[data-lkc-wl]');
  var api = String((me && me.getAttribute('data-api')) || '').trim().replace(/\/+$/, '');
  var loginPre = (me && me.getAttribute('data-login')) || '';
  // Wall-clock time this page started loading. Not performance.timeOrigin: Chromium can leave that hours
  // behind after a device sleeps, which would let an old sync reply beat a fresher island.
  var t0 = Date.now() - (w.performance && performance.now ? performance.now() : 0);
  var mem = null, mode = 'guest', cid = null, tk = '', cur = [], lastT = 0, checkAt = 0, ariaQ = false;
  var timer = 0, busy = false, failAt = 0, refreshed = false, chain = 0, toastEl = null, toastTimer = 0, tipped = false;

  function nid(x) { x = +x; return x > 0 && x <= 9007199254740991 && x % 1 === 0 ? x : 0; }
  function idList(a) {
    var r = [];
    if (Array.isArray(a)) a.forEach(function (x) { x = nid(x); if (x && r.length < MAX && r.indexOf(x) < 0) r.push(x); });
    return r;
  }
  function stamp() { var t = Date.now(); lastT = t > lastT ? t : lastT + 1; return lastT; }
  function byT(ops) { return ops.slice().sort(function (a, b) { return a.t - b.t; }); }
  function same(a, b) { return a.id === b.id && a.t === b.t; }

  /* ---- storage (in-memory copy if localStorage throws) ---- */
  function load() {
    var raw = mem, s, out = null;
    if (raw === null) { try { raw = localStorage.getItem(KEY); } catch (e) { raw = mem = '{}'; } }
    try { s = JSON.parse(raw || '{}') || {}; } catch (e) { s = {}; }
    if (s.out && s.out.cid && Array.isArray(s.out.ops)) {
      out = { cid: String(s.out.cid), ops: s.out.ops.filter(function (p) {
        return p && nid(p.id) && (p.o === 'a' || p.o === 'r') && typeof p.t === 'number';
      }).map(function (p) {
        var q = { o: p.o, id: nid(p.id), t: p.t };
        if (typeof p.s === 'number' && p.s > 0) q.s = p.s;
        return q;
      }) };
      if (Array.isArray(s.out.m) && s.out.m.length) out.m = idList(s.out.m);
    }
    return {
      guest: idList(s.guest),
      hm: s.hm && typeof s.hm === 'object' && !Array.isArray(s.hm) ? s.hm : {},
      acct: s.acct && s.acct.cid ? { cid: String(s.acct.cid), ids: idList(s.acct.ids), at: +s.acct.at || 0 } : null,
      out: out && out.ops.length ? out : null
    };
  }
  function save(s) {
    var keys = Object.keys(s.hm), keep = {}, n = 0, i;
    if (keys.length > 200) {
      s.guest.concat(s.acct ? s.acct.ids : [], s.out ? s.out.ops.map(function (p) { return p.id; }) : []).forEach(function (id) {
        if (s.hm[id] && !keep[id]) { keep[id] = s.hm[id]; n++; }
      });
      for (i = keys.length - 1; i >= 0 && n < 200; i--) if (!keep[keys[i]]) { keep[keys[i]] = s.hm[keys[i]]; n++; }
      s.hm = keep;
    }
    var str = JSON.stringify(s);
    if (mem === null) { try { localStorage.setItem(KEY, str); return; } catch (e) { /* fall through to memory */ } }
    mem = str;
  }

  /* ---- visible set + paint ---- */
  function visible(s) {
    if (mode !== 'account') return s.guest.slice(0, MAX);
    var v = s.acct && s.acct.cid === cid ? s.acct.ids.slice() : [];
    if (s.out && s.out.cid === cid) byT(s.out.ops).forEach(function (p) {
      var i = v.indexOf(p.id);
      if (p.o === 'a') { if (i < 0) v.unshift(p.id); } else if (i > -1) v.splice(i, 1);
    });
    return v.slice(0, MAX);
  }
  /* aria-pressed on every heart. Also run for hearts added later (filters, load more, recommendations).
     T6.31b (17 Sep 2026): data-wl-x = the X remove button on the shopper's own list (assets/lkc-wishlist-page.js),
     a plain button with no pressed state, so it is skipped here, on click and on focus. */
  function aria() {
    var on = {}, el = d.querySelectorAll('button[data-wl-id]:not([data-wl-x])'), i, v;
    ariaQ = false;
    cur.forEach(function (id) { on[id] = 1; });
    for (i = 0; i < el.length; i++) {
      v = on[el[i].getAttribute('data-wl-id')] ? 'true' : 'false';
      if (el[i].getAttribute('aria-pressed') !== v) el[i].setAttribute('aria-pressed', v);
    }
  }
  function paint(s) {
    cur = visible(s);
    var i, v, el;
    var sel = cur.map(function (id) { return '.lkc-wh[data-wl-id="' + id + '"] svg'; });
    var css = sel.length ? sel.join(',') + '{fill:currentColor}[data-wl-count]::after{content:"' + sel.length + '"}' : '';
    var st = d.getElementById('lkc-wl-state');
    if (!st) { st = d.createElement('style'); st.id = 'lkc-wl-state'; d.head.appendChild(st); }
    if (st.textContent !== css) st.textContent = css;
    d.documentElement.classList.toggle('lkc-wl-has', cur.length > 0);
    aria();
    el = d.querySelectorAll('[data-wl-count]');
    for (i = 0; i < el.length; i++) {
      v = el[i].closest('a');
      if (v) v.setAttribute('aria-label', cur.length ? 'Wishlist, ' + cur.length + ' saved' : 'Wishlist');
    }
  }
  function fire(extra) {
    try {
      var detail = { ids: cur.slice(), count: cur.length, mode: mode };
      for (var k in extra) detail[k] = extra[k];
      d.dispatchEvent(new CustomEvent('lkc:wishlist:change', { detail: detail }));
    } catch (e) { /* ignore */ }
  }

  /* ---- modes ---- */
  function enter(island) {
    var s = load(), now = Date.now();
    if (island && island.cid) {
      mode = 'account'; cid = String(island.cid); tk = typeof island.tk === 'string' ? island.tk : '';
      if (s.out && s.out.cid !== cid) s.out = null;
      /* A sync reply saved after this page started loading (another tab) is at least as fresh as the island. */
      if (!(s.acct && s.acct.cid === cid && s.acct.at > t0)) s.acct = { cid: cid, ids: idList(island.ids), at: 0 };
      if (s.out) {
        /* Drop ops the account list already shows (a page sent them and closed before reading the reply),
           and ops sent over 10 minutes ago whose reply nobody read. Unsent ops stay queued. */
        s.out.ops = s.out.ops.filter(function (p) {
          return (p.o === 'a') !== (s.acct.ids.indexOf(p.id) > -1) && !(p.s && now - p.s > SENT_TTL);
        });
        if (!s.out.ops.length) s.out = null;
      }
      if (s.guest.length) {
        var v = visible(s), add = s.guest.filter(function (id) { return v.indexOf(id) < 0; }).reverse();
        if (add.length) {
          s.out = s.out || { cid: cid, ops: [] };
          add.forEach(function (id) {
            s.out.ops = s.out.ops.filter(function (p) { return p.id !== id; });
            s.out.ops.push({ o: 'a', id: id, t: stamp() });
          });
          s.out.m = idList((s.out.m || []).concat(add));
        }
        s.guest = [];
      }
    } else {
      mode = 'guest'; cid = null; tk = '';
      s.acct = null;
    }
    save(s); paint(s);
  }
  function set(id, on, handle) {
    id = nid(id);
    if (!id) return false;
    var s = load(), changed;
    if (mode === 'account' && (!s.acct || s.acct.cid !== cid || (s.out && s.out.cid !== cid))) {
      /* Another tab logged out or changed customer: check the session before saving to anyone. */
      recheck();
      return false;
    }
    if (typeof handle === 'string' && handle) s.hm[id] = handle.slice(0, 255);
    changed = (visible(s).indexOf(id) > -1) !== on;
    if (changed && mode === 'account') {
      s.out = s.out || { cid: cid, ops: [] };
      s.out.ops = s.out.ops.filter(function (p) { return p.id !== id; });
      s.out.ops.push({ o: on ? 'a' : 'r', id: id, t: stamp() });
    } else if (changed) {
      s.guest = s.guest.filter(function (x) { return x !== id; });
      if (on) s.guest.unshift(id);
      s.guest = s.guest.slice(0, MAX);
    }
    save(s); paint(s);
    if (changed) {
      fire({ id: id, on: on });
      if (mode === 'account') { chain = 0; schedule(700); }
    }
    return changed;
  }

  /* ---- sync ---- */
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(function () { flush(false); }, ms); }
  /* Sets (at > 0) or clears the sent mark on the queued ops in batch. */
  function mark(batch, at) {
    try {
      var s = load();
      if (!s.out || s.out.cid !== cid) return;
      s.out.ops.forEach(function (p) {
        if (!batch.some(function (b) { return same(b, p); })) return;
        if (at) p.s = at; else delete p.s;
      });
      save(s);
    } catch (e) { /* ignore */ }
  }
  function flush(force) {
    clearTimeout(timer);
    if (busy || mode !== 'account' || !tk || !api || !w.fetch) return;
    var s = load();
    if (!s.out || s.out.cid !== cid) return;
    var wait = failAt + 10000 - Date.now();
    if (wait > 0 && force !== true) { schedule(wait); return; }
    var batch = byT(s.out.ops).slice(0, 100);
    function failed() { busy = false; mark(batch, 0); failAt = Date.now(); }
    busy = true;
    mark(batch, Date.now());
    try {
      fetch(api + '/v1/sync', {
        method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, credentials: 'omit',
        cache: 'no-store', keepalive: true,
        body: JSON.stringify({ tk: tk, ops: batch.map(function (p) { return { o: p.o, id: p.id, t: p.t }; }) })
      }).then(function (r) {
        return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) { /* not json */ } return { s: r.status, j: j }; });
      }).then(function (r) {
        busy = false;
        if (r.s === 200 && r.j && r.j.ok) return synced(batch, r.j);
        mark(batch, 0);
        /* token_invalid too: after a signing key change, a fresh token from the theme fixes it. Once per success. */
        if (r.s === 401 && r.j && (r.j.error === 'token_expired' || r.j.error === 'token_invalid') && !refreshed) {
          refreshed = true;
          return refresh().then(function (ok) { if (ok) flush(true); });
        }
        if (r.s === 400) {
          var s2 = load();
          unqueue(s2, batch, {});
          save(s2); paint(s2); fire({});
          return;
        }
        failAt = Date.now();
      }).catch(failed);
    } catch (e) { failed(); }
  }
  /* Drop sent ops whose t is unchanged (a newer tap on the same product stays queued), except keepIds. */
  function unqueue(s, batch, keepIds) {
    var kept = 0;
    if (s.out && s.out.cid === cid) {
      s.out.ops = s.out.ops.filter(function (p) {
        if (!batch.some(function (b) { return same(b, p); })) return true;
        if (keepIds[p.id]) { kept++; delete p.s; return true; }
        return false;
      });
      if (!s.out.ops.length) s.out = null;
    }
    return kept;
  }
  function synced(batch, j) {
    var skip = {}, s = load(), kept, ids = idList(j.ids), n = 0;
    var m = s.out && s.out.cid === cid && s.out.m ? s.out.m : null;
    idList(j.skipped).forEach(function (id) { skip[id] = 1; });
    kept = unqueue(s, batch, skip);
    s.acct = { cid: cid, ids: ids, at: Date.now() };
    if (j.handles && typeof j.handles === 'object') Object.keys(j.handles).forEach(function (k) {
      if (nid(k) && typeof j.handles[k] === 'string') s.hm[nid(k)] = j.handles[k].slice(0, 255);
    });
    /* Merge toast once no merged add is still queued: count only the ones the account really holds. */
    if (m && !(s.out && m.some(function (id) { return s.out.ops.some(function (p) { return p.id === id && p.o === 'a'; }); }))) {
      n = m.filter(function (id) { return ids.indexOf(id) > -1; }).length;
      if (s.out) delete s.out.m;
    }
    save(s); paint(s); fire({});
    refreshed = false; failAt = 0;
    if (n) toast('Added ' + n + ' saved item' + (n === 1 ? '' : 's') + ' to your account');
    /* Ops the Worker skipped (over its 20 new products per request) stay queued; resend a few times. */
    if (s.out && (!kept || chain++ < 5)) schedule(700);
  }
  function refresh() {
    return fetch('/cart?view=lkc-wl', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return false;
        if (!j.cid) { enter(null); fire({}); return false; }
        var s = load();
        if (String(j.cid) !== cid || !s.acct || s.acct.cid !== cid || (s.out && s.out.cid !== cid)) { enter(j); fire({}); return !!tk; }
        tk = typeof j.tk === 'string' ? j.tk : '';
        return !!tk;
      }).catch(function () { return false; });
  }
  /* Session check after another tab logged in, out or switched customer. At most once per 10s. */
  function recheck() {
    var now = Date.now();
    if (now - checkAt < 10000 || !w.fetch) return;
    checkAt = now;
    try { refresh(); } catch (e) { /* ignore */ }
  }

  /* ---- toast ---- */
  function toast(msg, tip) {
    try {
      var fresh = !toastEl, showTip = false;
      if (tip && loginPre) {
        try { showTip = !sessionStorage.getItem('lkc.wl.tip'); sessionStorage.setItem('lkc.wl.tip', '1'); } catch (e) { showTip = !tipped; }
        tipped = true;
      }
      if (fresh) {
        toastEl = d.createElement('div');
        toastEl.id = 'lkc-wishlist-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        d.body.appendChild(toastEl);
      }
      setTimeout(function () {
        var span = d.createElement('span'), a;
        span.textContent = msg;
        toastEl.textContent = '';
        toastEl.appendChild(span);
        if (showTip) {
          a = d.createElement('a');
          a.href = loginPre + encodeURIComponent(location.pathname + location.search);
          a.textContent = 'Log in to keep it on every device';
          toastEl.appendChild(a);
        }
        toastEl.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
          toastEl.classList.remove('is-visible');
          /* Empty it after the fade so the hidden tip link is not left in the tab order or read out later. */
          toastTimer = setTimeout(function () { toastEl.textContent = ''; }, 250);
        }, showTip ? 5000 : 2400);
      }, fresh ? 60 : 0);
    } catch (e) { /* ignore */ }
  }

  /* ---- clicks: bubble phase, preventDefault only (no stopPropagation, GTM and analytics still see it) ---- */
  function handleFrom(btn) {
    var box = btn.closest('.spf-product-card__inner') || btn.parentNode;
    var a = box && box.querySelector('a[href*="/products/"]');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  var downX = 0, downY = 0, downTouch = false, lastXAt = 0;
  d.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; downTouch = e.pointerType === 'touch'; }, { capture: true, passive: true });
  d.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[data-wl-id]') : null;
    if (!btn) return;
    e.preventDefault();
    /* Carousel drags are mouse/pen only (touch swipes scroll and never click), so taps that drift still count. */
    if (e.detail > 0 && !downTouch && (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6)) return;
    try {
      var id = nid(btn.getAttribute('data-wl-id')), isX = btn.hasAttribute('data-wl-x');
      if (!id) return;
      /* T6.31b (17 Sep 2026): an X removes its card at once and the next card's X slides under the pointer, so the
         second click of a double click or quick double tap is ignored (within 400ms). Keyboard presses (detail 0) are not. */
      if (isX && e.detail > 0 && (e.detail > 1 || Date.now() - lastXAt < 400)) return;
      var on = !isX && visible(load()).indexOf(id) < 0; /* an X only ever removes */
      if (!set(id, on, btn.getAttribute('data-product-handle') || handleFrom(btn))) return;
      if (isX) lastXAt = Date.now(); else btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      toast(on ? 'Saved to your wishlist' : 'Removed from your wishlist', on && mode === 'guest');
      /* After this click reaches window, the lazy GTM loader has created dataLayer. */
      setTimeout(function () {
        if (w.dataLayer && typeof w.dataLayer.push === 'function') w.dataLayer.push({ event: 'lkc_wishlist', action: on ? 'add' : 'remove', product_id: id });
      }, 0);
    } catch (x) { /* ignore */ }
  });
  d.addEventListener('focusin', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[data-wl-id]:not([data-wl-x])') : null;
    if (btn) btn.setAttribute('aria-pressed', cur.indexOf(nid(btn.getAttribute('data-wl-id'))) > -1 ? 'true' : 'false');
  });
  /* Hearts inserted later start as aria-pressed="false": fix them on the next frame. Paint itself needs no observer. */
  try {
    new MutationObserver(function (list) {
      var i, j, a, n;
      if (ariaQ) return;
      for (i = 0; i < list.length; i++) {
        for (j = 0, a = list[i].addedNodes; j < a.length; j++) {
          n = a[j];
          if (n.nodeType === 1 && (n.matches('button[data-wl-id]') || n.querySelector('button[data-wl-id]'))) {
            ariaQ = true;
            requestAnimationFrame(aria);
            return;
          }
        }
      }
    }).observe(d.documentElement, { childList: true, subtree: true });
  } catch (e) { /* no observer: focusin still corrects hearts that get focus */ }

  /* ---- other tabs, leaving the page ---- */
  w.addEventListener('storage', function (e) {
    if (e.key !== KEY && e.key !== null) return;
    try {
      var s = load();
      if ((s.acct ? s.acct.cid : null) !== cid) recheck(); /* logged in, out or switched in another tab */
      paint(s); fire({});
    } catch (x) { /* ignore */ }
  });
  w.addEventListener('pageshow', function (e) { if (e.persisted) { try { paint(load()); } catch (x) { /* ignore */ } } });
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') flush(false); });
  w.addEventListener('pagehide', function () { flush(false); });

  w.LKCWishlist = {
    has: function (id) { return cur.indexOf(nid(id)) > -1; },
    list: function () { return cur.slice(); },
    count: function () { return cur.length; },
    toggle: function (id, handle) { var on = visible(load()).indexOf(nid(id)) < 0; return set(id, on, handle) ? on : !on; },
    add: function (id, handle) { return set(id, true, handle); },
    remove: function (id) { return set(id, false); },
    mode: function () { return mode; },
    handleOf: function (id) { var h = load().hm[nid(id)]; return typeof h === 'string' ? h : ''; },
    rememberHandle: function (id, handle) {
      id = nid(id);
      if (!id || typeof handle !== 'string' || !handle) return;
      var s = load(); s.hm[id] = handle.slice(0, 255); save(s);
    },
    toast: function (msg) { toast(String(msg)); }
  };

  try {
    try { localStorage.removeItem('lkc.wishlist.v1'); } catch (e) { /* May T5.50 key, never launched */ }
    var isl = null, el = d.getElementById('lkc-wl-acct');
    if (el) { try { isl = JSON.parse(el.textContent); } catch (e) { isl = null; } }
    enter(isl);
    if (mode === 'account' && load().out) {
      var later = function () { setTimeout(function () { flush(false); }, 1000); };
      if (d.readyState === 'complete') later(); else w.addEventListener('load', later);
    }
  } catch (e) { /* ignore */ }
})();
